(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cafe-slider-videos-marcas"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cafe-video-text-slider')) {
  customElements.define(
    'cafe-video-text-slider',
    class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }

      init() {
        if (this.ready || !this.isConnected) return;
        this.ready = true;

        this.abort = new AbortController();
        const signal = this.abort.signal;

        this.slides = Array.from(this.querySelectorAll('.cs-slide'));
        this.prev = this.querySelector('.cs-prev');
        this.next = this.querySelector('.cs-next');
        this.counter = this.querySelector('[data-current]');
        this.status = this.querySelector('[data-status]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');

        this.index = 0;
        this.visible = false;
        this.enoughVisible = false;
        this.started = false;
        this.queue = [];
        this.originals = [];
        this.part = 0;
        this.timer = null;
        this.userPaused = new WeakSet();
        this.manualPlay = new WeakSet();

        this.resize = () => {
          this.style.width = '';
          this.style.marginLeft = '';

          const left = this.getBoundingClientRect().left;
          this.style.width = document.documentElement.clientWidth + 'px';
          this.style.marginLeft = -left + 'px';
        };

        this.resize();
        window.addEventListener('resize', this.resize, { signal });

        if (!this.slides.length) return;

        this.slides.forEach((slide) => {
          const video = slide.querySelector('video');
          const control = slide.querySelector('.cs-video-control');

          if (!video || !control) return;

          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          control.hidden = false;

          control.addEventListener('click', () => {
            if (video.paused) {
              this.userPaused.delete(video);
              this.manualPlay.add(video);
              this.play(video);
            } else {
              this.userPaused.add(video);
              this.manualPlay.delete(video);
              video.pause();
            }
          }, { signal });

          video.addEventListener('play', () => {
            if (video !== this.currentVideo() || !this.canRun()) {
              video.pause();
              return;
            }
            control.textContent = 'Pausar video';
          }, { signal });

          video.addEventListener('pause', () => {
            control.textContent = 'Reproducir video';
          }, { signal });
        });

        if (this.prev && this.next) {
          this.prev.hidden = false;
          this.next.hidden = false;

          this.prev.addEventListener('click', () => {
            this.go(this.index - 1);
          }, { signal });

          this.next.addEventListener('click', () => {
            this.go(this.index + 1);
          }, { signal });

          this.addEventListener('keydown', (event) => {
            if (
              event.target.closest('input, textarea, select, [contenteditable]')
            ) return;

            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.go(this.index - 1);
            }

            if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.go(this.index + 1);
            }
          }, { signal });
        }

        document.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex(
            slide => slide.dataset.blockId === event.detail.blockId
          );

          if (index !== -1) this.go(index, true);
        }, { signal });

        document.addEventListener('visibilitychange', () => {
          this.syncActivity();
        }, { signal });

        this.motion.addEventListener('change', () => {
          if (this.motion.matches) {
            this.restoreText();
            this.queue = [];
            this.slides.forEach(slide => {
              slide.querySelector('video')?.pause();
            });
          }
          this.syncActivity();
        }, { signal });

        this.go(0, true);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            const entry = entries[entries.length - 1];

            this.visible = entry.isIntersecting;

            const viewportHeight = entry.rootBounds
              ? entry.rootBounds.height
              : window.innerHeight;

            const targetHeight = Math.min(
              entry.boundingClientRect.height,
              viewportHeight
            ) * 0.6;

            this.enoughVisible =
              this.visible &&
              entry.intersectionRect.height >= targetHeight;

            this.syncActivity();
          }, {
            threshold: Array.from({ length: 101 }, (_, i) => i / 100)
          });

          this.observer.observe(this);
        } else {
          this.visible = true;
          this.enoughVisible = true;
          this.syncActivity();
        }
      }

      currentSlide() {
        return this.slides[this.index];
      }

      currentVideo() {
        return this.currentSlide()?.querySelector('video');
      }

      canRun() {
        return (
          this.isConnected &&
          this.visible &&
          !document.hidden
        );
      }

      go(requested, force = false) {
        const total = this.slides.length;
        if (!total) return;

        let nextIndex = requested;

        if (this.dataset.loop === 'true') {
          nextIndex = ((requested % total) + total) % total;
        } else {
          nextIndex = Math.max(0, Math.min(requested, total - 1));
        }

        if (nextIndex === this.index && !force) return;

        const previousSlide = this.currentSlide();
        const focusedInside = previousSlide?.contains(document.activeElement);
        const direction = requested < this.index ? -1 : 1;

        this.restoreText();

        this.slides.forEach((slide, index) => {
          slide.querySelector('video')?.pause();
          slide.classList.remove('is-entering');

          const selected = index === nextIndex;
          slide.classList.toggle('is-active', selected);
          slide.inert = !selected;

          if (selected) {
            slide.removeAttribute('aria-hidden');
          } else {
            slide.setAttribute('aria-hidden', 'true');
          }
        });

        this.index = nextIndex;
        this.started = false;
        this.part = 0;
        this.queue = [];

        const slide = this.currentSlide();
        slide.style.setProperty('--entry-x', `${direction * 24}px`);

        if (!force && !this.motion.matches) {
          void slide.offsetWidth;
          slide.classList.add('is-entering');
        }

        this.prepareText();

        if (this.counter) {
          this.counter.textContent = String(this.index + 1);
        }

        if (this.prev && this.next) {
          const loop = this.dataset.loop === 'true';
          this.prev.disabled = !loop && this.index === 0;
          this.next.disabled = !loop && this.index === total - 1;
        }

        if (!force && this.status) {
          this.status.textContent =
            `Diapositiva ${this.index + 1} de ${total}`;
        }

        if (focusedInside) {
          const focusTarget =
            this.next && !this.next.disabled ? this.next : this.prev;
          focusTarget?.focus({ preventScroll: true });
        }

        this.syncActivity();
      }

      prepareText() {
        if (this.motion.matches) return;

        this.currentSlide()
          .querySelectorAll('[data-typewriter="true"]')
          .forEach((element) => {
            const text = element.textContent;
            this.originals.push([element, text]);

            const accessible = document.createElement('span');
            accessible.className = 'cs-sr';
            accessible.textContent = text;

            const visual = document.createElement('span');
            visual.className = 'cs-visual';
            visual.setAttribute('aria-hidden', 'true');

            const ghost = document.createElement('span');
            ghost.className = 'cs-ghost';
            ghost.textContent = text;

            const typed = document.createElement('span');
            typed.className = 'cs-typed';

            const output = document.createTextNode('');

            const caret = document.createElement('span');
            caret.className = 'cs-caret';
            caret.hidden = true;

            typed.append(output, caret);
            visual.append(ghost, typed);
            element.replaceChildren(accessible, visual);

            const chars = typeof Intl.Segmenter === 'function'
              ? Array.from(
                  new Intl.Segmenter(
                    document.documentElement.lang || 'es',
                    { granularity: 'grapheme' }
                  ).segment(text),
                  segment => segment.segment
                )
              : Array.from(text);

            this.queue.push({
              output,
              caret,
              chars,
              index: 0
            });
          });
      }

      restoreText() {
        clearTimeout(this.timer);
        this.timer = null;

        (this.originals || []).forEach(([element, text]) => {
          element.textContent = text;
        });

        this.originals = [];
      }

      syncActivity() {
        const video = this.currentVideo();

        if (!this.canRun()) {
          clearTimeout(this.timer);
          this.timer = null;
          video?.pause();
          return;
        }

        if (
          video &&
          video.paused &&
          !this.userPaused.has(video) &&
          (!this.motion.matches || this.manualPlay.has(video))
        ) {
          this.play(video);
        }

        if (this.motion.matches) return;

        if (!this.started && this.enoughVisible) {
          this.started = true;
          this.schedule(Number(this.currentSlide().dataset.delay) || 0);
        } else if (this.started) {
          this.schedule(Number(this.currentSlide().dataset.speed) || 45);
        }
      }

      play(video) {
        if (!video || video !== this.currentVideo() || !this.canRun()) {
          return;
        }

        const pending = video.play();

        if (pending) {
          pending.then(() => {
            if (video !== this.currentVideo() || !this.canRun()) {
              video.pause();
            }
          }).catch(() => {
            const control =
              video.closest('.cs-slide').querySelector('.cs-video-control');

            if (control) {
              control.textContent = 'Reproducir video';
            }
          });
        }
      }

      schedule(delay) {
        if (
          this.timer !== null ||
          !this.queue[this.part] ||
          !this.canRun()
        ) return;

        this.timer = setTimeout(() => {
          this.timer = null;
          this.tick();
        }, delay);
      }

      tick() {
        if (!this.canRun()) return;

        const item = this.queue[this.part];
        if (!item) return;

        item.caret.hidden = false;

        if (item.index < item.chars.length) {
          item.output.appendData(item.chars[item.index++]);
          this.schedule(Number(this.currentSlide().dataset.speed) || 45);
        } else if (this.part < this.queue.length - 1) {
          item.caret.hidden = true;
          this.part++;
          this.schedule(300);
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.restoreText();
        this.observer?.disconnect();
        this.abort?.abort();

        this.querySelectorAll('video').forEach(video => video.pause());
        this.ready = false;
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-4bloques"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cafe-product-grid')) {
    customElements.define('cafe-product-grid', class extends HTMLElement {
      connectedCallback() {
        // A registered custom element can connect before its children are parsed.
        if (this.abort || this.startFrame || this.onDomReady) return;
        const schedule = () => {
          this.onDomReady = null;
          this.startFrame = requestAnimationFrame(() => {
            this.startFrame = null;
            if (this.isConnected) this.initialize();
          });
        };
        if (document.readyState === 'loading') {
          this.onDomReady = schedule;
          document.addEventListener('DOMContentLoaded', schedule, { once: true });
        } else schedule();
      }
      initialize() {
        if (this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.cards = Array.from(this.querySelectorAll('[data-cpg-card]'));
        this.inView = new Set();
        this.manualPause = new WeakSet();
        this.manualPlay = new WeakSet();
        this.pendingPlay = new WeakSet();
        this.blockedPlay = new WeakSet();
        const animate = this.dataset.animate === 'true' && !this.motion.matches && 'IntersectionObserver' in window;
        this.classList.toggle('cpg-ready', animate);

        this.cards.forEach(card => {
          const video = card.querySelector('video');
          const button = card.querySelector('[data-cpg-toggle]');
          if (!video || !button) return;
          button.hidden = false;
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          video.setAttribute('loading', 'eager');
          video.preload = 'metadata';
          const update = () => {
            const action = video.paused ? 'Reproducir' : 'Pausar';
            button.querySelector('[data-cpg-toggle-label]').textContent = action;
            button.setAttribute('aria-label', action + ' video de fondo: ' + button.dataset.title);
          };
          video.addEventListener('play', update, { signal });
          video.addEventListener('pause', update, { signal });
          video.addEventListener('loadeddata', () => this.syncVideos(), { signal });
          video.addEventListener('canplay', () => this.syncVideos(), { signal });
          video.addEventListener('error', () => {
            video.dataset.playbackError = 'media-' + (video.error ? video.error.code : 'unknown');
            button.querySelector('[data-cpg-toggle-label]').textContent = 'Reintentar';
            button.setAttribute('aria-label', 'Reintentar video de fondo: ' + button.dataset.title);
          }, { signal });
          button.addEventListener('click', () => {
            if (video.paused) {
              this.manualPause.delete(video);
              this.manualPlay.add(video);
              this.blockedPlay.delete(video);
              if (video.error) video.load();
              this.startVideo(video);
            } else {
              this.manualPause.add(video);
              this.manualPlay.delete(video);
              video.pause();
            }
          }, { signal });
          update();
          // Explicitly start resource selection, including after editor reloads.
          video.load();
        });

        this.addEventListener('focusin', event => {
          const card = event.target.closest('[data-cpg-card]');
          if (card) card.classList.add('cpg-visible', 'cpg-immediate');
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-cpg-card]');
          if (card) card.classList.add('cpg-visible', 'cpg-immediate');
        }, { signal });
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) {
            this.classList.remove('cpg-ready');
            this.cards.forEach(card => card.classList.add('cpg-visible'));
            this.manualPlay = new WeakSet();
          }
          this.syncVideos();
        }, { signal });
        document.addEventListener('visibilitychange', () => this.syncVideos(), { signal });

        // Start visible videos without waiting for an observer's first delivery.
        this.cards.forEach(card => {
          const rect = card.getBoundingClientRect();
          if (rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth) {
            this.inView.add(card);
          }
        });
        this.syncVideos();
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                entry.target.classList.add('cpg-visible');
                this.inView.add(entry.target);
              } else {
                this.inView.delete(entry.target);
              }
            });
            this.syncVideos();
          }, { threshold: 0.15 });
          this.cards.forEach(card => this.observer.observe(card));
        } else {
          this.cards.forEach(card => this.inView.add(card));
          this.syncVideos();
        }
      }
      startVideo(video) {
        if (this.pendingPlay.has(video) || this.blockedPlay.has(video)) return;
        this.pendingPlay.add(video);
        const pending = this.pendingPlay;
        Promise.resolve(video.play()).then(() => {
          delete video.dataset.playbackError;
          if (!this.isConnected) video.pause();
          else this.syncVideos();
        }).catch(error => {
          if (error.name !== 'AbortError') {
            video.dataset.playbackError = error.name;
            this.blockedPlay.add(video);
          }
        }).finally(() => pending.delete(video));
      }
      syncVideos() {
        this.cards.forEach(card => {
          const video = card.querySelector('video');
          if (!video) return;
          const shouldPlay = this.inView.has(card) && !document.hidden && !this.manualPause.has(video) && (!this.motion.matches || this.manualPlay.has(video));
          if (shouldPlay) {
            if (video.paused) this.startVideo(video);
          } else {
            video.pause();
          }
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        this.startFrame = null;
        if (this.onDomReady) document.removeEventListener('DOMContentLoaded', this.onDomReady);
        this.onDomReady = null;
        this.observer?.disconnect();
        this.abort?.abort();
        this.abort = null;
        this.querySelectorAll('video').forEach(video => video.pause());
        this.classList.remove('cpg-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-banner-certificaciones"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cafe-certifications')) {
    customElements.define(
      'cafe-certifications',
      class extends HTMLElement {
        connectedCallback() {
          this.startFrame = requestAnimationFrame(() => this.init());
        }

        init() {
          if (this.initialized) return;
          this.initialized = true;

          this.abort = new AbortController();
          const signal = this.abort.signal;

          this.track = this.querySelector('.cert-track');
          this.group = this.querySelector('.cert-group');
          this.windowElement = this.querySelector('.cert-window');
          this.motionButton = this.querySelector('.cert-motion-button');
          this.videoButton = this.querySelector('.cert-video-button');
          this.video = this.querySelector('video');

          this.motionPreference = matchMedia(
            '(prefers-reduced-motion: reduce)'
          );

          this.originalItems = Array.from(this.group.children);
          this.userPaused = false;
          this.videoPausedByUser = false;
          this.visible = false;

          this.scheduleLayout = () => {
            cancelAnimationFrame(this.layoutFrame);
            this.layoutFrame = requestAnimationFrame(() => {
              this.layout();
            });
          };

          window.addEventListener(
            'resize',
            this.scheduleLayout,
            { signal }
          );

          this.motionPreference.addEventListener(
            'change',
            () => {
              this.scheduleLayout();

              if (this.motionPreference.matches && this.video) {
                this.video.pause();
              }
            },
            { signal }
          );

          this.motionButton.addEventListener(
            'click',
            () => {
              this.userPaused = !this.userPaused;
              this.updatePauseState();
            },
            { signal }
          );

          if (this.video) {
            this.video.muted = true;
            this.video.defaultMuted = true;
            this.video.playsInline = true;
            this.videoButton.hidden = false;

            this.videoButton.addEventListener(
              'click',
              () => {
                if (this.video.paused) {
                  this.videoPausedByUser = false;
                  this.playVideo();
                } else {
                  this.videoPausedByUser = true;
                  this.video.pause();
                }
              },
              { signal }
            );

            this.video.addEventListener(
              'play',
              () => {
                this.videoButton.textContent = 'Pausar video';
              },
              { signal }
            );

            this.video.addEventListener(
              'pause',
              () => {
                this.videoButton.textContent = 'Reproducir video';
              },
              { signal }
            );
          }

          this.layout();

          if ('IntersectionObserver' in window) {
            this.intersectionObserver = new IntersectionObserver(
              (entries) => {
                const entry = entries[entries.length - 1];
                this.visible = entry.isIntersecting;
                this.updatePauseState();

                if (!this.video) return;

                if (!this.visible) {
                  this.video.pause();
                } else if (
                  !this.videoPausedByUser &&
                  !this.motionPreference.matches
                ) {
                  this.playVideo();
                }
              }
            );

            this.intersectionObserver.observe(this);
          } else {
            this.visible = true;
            this.updatePauseState();

            if (this.video && !this.motionPreference.matches) {
              this.playVideo();
            }
          }

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => {
              const width = document.documentElement.clientWidth;

              if (width !== this.lastViewportWidth) {
                this.scheduleLayout();
              }
            });

            this.resizeObserver.observe(document.documentElement);
          }

          document.addEventListener(
            'shopify:block:select',
            (event) => {
              if (!this.contains(event.target)) return;

              this.editorSelected = true;
              this.layout();
            },
            { signal }
          );

          document.addEventListener(
            'shopify:block:deselect',
            (event) => {
              if (!this.contains(event.target)) return;

              this.editorSelected = false;
              this.layout();
            },
            { signal }
          );
        }

        decorativeClone(node) {
          const clone = node.cloneNode(true);

          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-shopify-editor-block');
          clone.removeAttribute('id');

          clone.querySelectorAll('[id]').forEach((el) => {
            el.removeAttribute('id');
          });

          clone.querySelectorAll('img').forEach((img) => {
            img.alt = '';
            img.loading = 'eager';
          });

          return clone;
        }

        layout() {
          if (!this.isConnected) return;

          this.style.width = '';
          this.style.marginLeft = '';

          const left = this.getBoundingClientRect().left;
          const viewportWidth = document.documentElement.clientWidth;

          this.lastViewportWidth = viewportWidth;
          this.style.width = viewportWidth + 'px';
          this.style.marginLeft = -left + 'px';

          this.classList.remove('is-moving');

          this.track.replaceChildren(this.group);
          this.group.replaceChildren(...this.originalItems);

          const shouldMove =
            this.dataset.moving === 'true' &&
            !this.motionPreference.matches &&
            !this.editorSelected &&
            this.originalItems.length > 0;

          this.motionButton.hidden = !shouldMove;

          if (!shouldMove) return;

          this.classList.add('is-moving');

          const baseWidth = this.group.getBoundingClientRect().width;
          const viewport = this.windowElement.clientWidth;

          if (baseWidth <= 0) return;

          const repeats = Math.max(
            1,
            Math.ceil(viewport / baseWidth)
          );

          for (let i = 1; i < repeats; i++) {
            this.originalItems.forEach((item) => {
              this.group.append(this.decorativeClone(item));
            });
          }

          const groupWidth = this.group.getBoundingClientRect().width;
          const pixelsPerSecond = Number(this.dataset.speed) || 45;

          this.style.setProperty(
            '--duration',
            groupWidth / pixelsPerSecond + 's'
          );

          this.track.append(this.decorativeClone(this.group));
          this.updatePauseState();
        }

        updatePauseState() {
          this.classList.toggle(
            'is-paused',
            this.userPaused || !this.visible
          );

          this.motionButton.textContent = this.userPaused
            ? 'Reanudar logos'
            : 'Pausar logos';
        }

        playVideo() {
          const result = this.video.play();

          if (result) {
            result.catch(() => {
              if (this.videoButton) {
                this.videoButton.textContent = 'Reproducir video';
              }
            });
          }
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.startFrame);
          cancelAnimationFrame(this.layoutFrame);

          if (this.abort) this.abort.abort();
          if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
          }
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.video) this.video.pause();

          if (this.group && this.originalItems) {
            this.group.replaceChildren(...this.originalItems);
            this.track.replaceChildren(this.group);
          }

          this.classList.remove('is-moving', 'is-paused');
          this.initialized = false;
          this.editorSelected = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-banner-parrafos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cafe-paragraph-banner')) {
    customElements.define(
      'cafe-paragraph-banner',
      class extends HTMLElement {
        connectedCallback() {
          this.updateWidth = this.updateWidth.bind(this);
          this.scheduleUpdate = this.scheduleUpdate.bind(this);

          window.addEventListener('resize', this.scheduleUpdate);

          this.scheduleUpdate();

          if ('ResizeObserver' in window) {
            this.observer = new ResizeObserver(this.scheduleUpdate);
            this.observer.observe(document.documentElement);

            if (this.parentElement) {
              this.observer.observe(this.parentElement);
            }
          }
        }

        scheduleUpdate() {
          cancelAnimationFrame(this.frame);

          this.frame = requestAnimationFrame(() => {
            this.updateWidth();
          });
        }

        updateWidth() {
          if (!this.isConnected) return;

          this.style.width = '';
          this.style.marginLeft = '';

          const left = this.getBoundingClientRect().left;
          const viewportWidth = document.documentElement.clientWidth;

          this.style.width = viewportWidth + 'px';
          this.style.marginLeft = -left + 'px';
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          window.removeEventListener('resize', this.scheduleUpdate);

          if (this.observer) {
            this.observer.disconnect();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-banner-texto-degradado"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cafe-gradient-banner')) {
    customElements.define(
      'cafe-gradient-banner',
      class extends HTMLElement {
        connectedCallback() {
          this.onResize = () => {
            cancelAnimationFrame(this.frame);

            this.frame = requestAnimationFrame(() => {
              this.updateWidth();
            });
          };

          window.addEventListener('resize', this.onResize);
          this.onResize();

          if ('ResizeObserver' in window) {
            this.observer = new ResizeObserver(this.onResize);
            this.observer.observe(document.documentElement);

            if (this.parentElement) {
              this.observer.observe(this.parentElement);
            }
          }
        }

        updateWidth() {
          if (!this.isConnected) return;

          this.style.width = '';
          this.style.marginLeft = '';

          const left = this.getBoundingClientRect().left;
          const width = document.documentElement.clientWidth;

          this.style.width = width + 'px';
          this.style.marginLeft = -left + 'px';
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          window.removeEventListener('resize', this.onResize);

          if (this.observer) {
            this.observer.disconnect();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-cafe-columnas-interactivas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cafe-columns')) customElements.define('cafe-columns', class extends HTMLElement {
    connectedCallback() {
      if (this.dispose || this.frame || this.onReady) return;
      const start = () => { this.onReady = null; this.frame = requestAnimationFrame(() => { this.frame = null; if (this.isConnected) this.initialize(); }); };
      if (document.readyState === 'loading') { this.onReady = start; document.addEventListener('DOMContentLoaded', start, { once: true }); } else start();
    }
    initialize() {
      this.dispose = []; this.columns = Array.from(this.querySelectorAll('.cc-column')); this.active = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)'); this.visible = false;
      this.paused = new WeakSet(); this.requested = new WeakSet(); this.pending = new WeakSet(); this.blocked = new WeakSet();
      const listen = (target, name, fn) => { target.addEventListener(name, fn); this.dispose.push(() => target.removeEventListener(name, fn)); };
      this.track = this.querySelector('.cc-track'); this.status = this.querySelector('[data-status]');
      const resize = () => {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => {
          this.style.setProperty('--cc-width', '100%'); this.style.setProperty('--cc-left', '0px');
          const left = this.getBoundingClientRect().left;
          this.style.setProperty('--cc-width', document.documentElement.clientWidth + 'px');
          this.style.setProperty('--cc-left', -left + 'px'); this.style.setProperty('--cc-height', innerHeight + 'px');
        });
      };
      listen(window, 'resize', resize); resize();
      this.columns.forEach((column, index) => {
        listen(column.querySelector('[data-select]'), 'click', () => this.select(index));
        listen(column.querySelector('[data-preview]'), 'click', () => this.select(index === this.active && this.dataset.next === 'true' ? index + 1 : index));
        column.querySelectorAll('[data-select], [data-preview]').forEach(button => listen(button, 'keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = this.active + 1;
          if (event.key === 'ArrowLeft') next = this.active - 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.columns.length - 1;
          if (next !== undefined) { event.preventDefault(); this.select(next); this.columns[this.active].querySelector('[data-select]').focus({ preventScroll: true }); }
        }));
      });
      this.videos = Array.from(this.querySelectorAll('video'));
      this.videos.forEach(video => {
        video.muted = true; video.defaultMuted = true; video.playsInline = true;
        const column = video.closest('.cc-column');
        const button = column ? column.querySelector('[data-play]') : this.querySelector('[data-bg-toggle]');
        const update = () => {
          video.classList.toggle('is-playing', !video.paused);
          if (button) { button.textContent = (video.paused ? 'Reproducir' : 'Pausar') + (column ? '' : ' fondo'); button.setAttribute('aria-label', button.textContent + (column ? ' video de ' + column.querySelector('.cc-heading').textContent : '')); }
        };
        listen(video, 'play', update); listen(video, 'pause', update);
        if (button) listen(button, 'click', () => {
          if (video.paused) { this.paused.delete(video); this.blocked.delete(video); this.requested.add(video); this.play(video); }
          else { this.paused.add(video); this.requested.delete(video); video.pause(); }
        });
        update();
      });
      listen(this.querySelector('[data-prev]'), 'click', () => this.select(this.active - 1));
      listen(this.querySelector('[data-forward]'), 'click', () => this.select(this.active + 1));
      listen(this, 'shopify:block:select', event => { const column = event.target.closest('.cc-column'); if (column) this.select(this.columns.indexOf(column)); });
      listen(document, 'visibilitychange', () => this.sync());
      listen(this.motion, 'change', () => { this.requested = new WeakSet(); this.sync(); });
      this.querySelector('.cc-controls').hidden = !this.columns.length;
      this.select(0, false);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: 0.05 }); this.observer.observe(this);
      } else { this.visible = true; this.sync(); }
    }
    select(index, scroll = true) {
      if (!this.columns.length) return;
      this.active = ((index % this.columns.length) + this.columns.length) % this.columns.length;
      this.columns.forEach((column, i) => {
        const active = i === this.active;
        column.classList.toggle('is-active', active); column.querySelector('.cc-detail').hidden = !active;
        column.querySelectorAll('[data-select], [data-preview]').forEach(b => b.setAttribute('aria-expanded', String(active)));
        const preview = column.querySelector('[data-preview]');
        preview.setAttribute('aria-label', active && this.dataset.next === 'true' ? 'Mostrar siguiente columna' : 'Mostrar ' + column.querySelector('.cc-heading').textContent);
        const play = column.querySelector('[data-play]'); if (play) play.hidden = !active;
      });
      this.status.textContent = (this.active + 1) + ' / ' + this.columns.length;
      this.sync();
      clearTimeout(this.scrollTimer);
      if (scroll) this.scrollTimer = setTimeout(() => {
        if (!this.isConnected) return;
        const column = this.columns[this.active], rect = column.getBoundingClientRect(), track = this.track.getBoundingClientRect();
        this.track.scrollTo({ left: this.track.scrollLeft + rect.left - track.left - 16, behavior: this.motion.matches ? 'auto' : 'smooth' });
      }, this.motion.matches ? 0 : parseFloat(getComputedStyle(this).getPropertyValue('--cc-duration')) || 600);
    }
    play(video) {
      if (this.pending.has(video) || this.blocked.has(video)) return;
      this.pending.add(video);
      video.play().then(() => { if (!this.isConnected) video.pause(); else this.sync(); }).catch(error => {
        if (error.name !== 'AbortError') { this.blocked.add(video); video.dataset.playbackError = error.name; }
      }).finally(() => this.pending.delete(video));
    }
    sync() {
      (this.videos || []).forEach(video => {
        const column = video.closest('.cc-column');
        const active = !column || this.columns[this.active] === column;
        if (this.visible && !document.hidden && active && !this.paused.has(video) && (!this.motion.matches || this.requested.has(video))) {
          if (video.paused) this.play(video);
        } else video.pause();
      });
    }
    disconnectedCallback() {
      if (this.onReady) document.removeEventListener('DOMContentLoaded', this.onReady);
      this.onReady = null; cancelAnimationFrame(this.frame); this.frame = null; cancelAnimationFrame(this.resizeFrame); clearTimeout(this.scrollTimer);
      this.observer?.disconnect(); this.dispose?.forEach(fn => fn()); this.dispose = null; this.querySelectorAll('video').forEach(v => v.pause());
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-circulo-animacion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cafe-orbit')) {
    customElements.define('cafe-orbit', class extends HTMLElement {
      connectedCallback() {
        if (this.dispose || this.onReady || this.startFrame) return;
        const start = () => {
          this.onReady = null;
          this.startFrame = requestAnimationFrame(() => {
            this.startFrame = null;
            if (this.isConnected) this.initialize();
          });
        };
        if (document.readyState === 'loading') {
          this.onReady = start; document.addEventListener('DOMContentLoaded', start, { once: true });
        } else start();
      }
      initialize() {
        this.dispose = [];
        const listen = (target, event, fn) => {
          target.addEventListener(event, fn);
          this.dispose.push(() => target.removeEventListener(event, fn));
        };
        const size = () => {
          cancelAnimationFrame(this.sizeFrame);
          this.sizeFrame = requestAnimationFrame(() => {
            this.style.setProperty('--orb-left', '0px');
            this.style.setProperty('--orb-width', '100%');
            const left = this.getBoundingClientRect().left;
            const width = document.documentElement.clientWidth;
            this.style.setProperty('--orb-left', -left + 'px');
            this.style.setProperty('--orb-width', width + 'px');
            this.style.setProperty('--orb-height', window.innerHeight + 'px');
            const height = this.getBoundingClientRect().height;
            const compositionSize = Math.max(1, Math.min(width - 40, height - 80, Number(this.dataset.maxSize) || 1100));
            this.style.setProperty('--orb-size', compositionSize + 'px');
            this.style.setProperty('--orb-text-scale', Math.min(1, compositionSize / (width <= 749 ? 406 : 925)));
          });
        };
        listen(window, 'resize', size); size();
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(size);
          this.resizeObserver.observe(this.parentElement);
        }
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.video = this.querySelector('video');
        this.button = this.querySelector('.orb-video-toggle');
        this.visible = false; this.userPaused = false; this.userStarted = false; this.pending = false; this.blocked = false;
        if (this.dataset.animation === 'true' && !this.motion.matches && 'IntersectionObserver' in window) this.classList.add('orb-ready');
        const reveal = () => this.classList.add('orb-visible');
        if (this.video && this.button) {
          this.button.hidden = false; this.video.muted = true; this.video.defaultMuted = true; this.video.playsInline = true;
          const update = () => {
            const label = this.video.paused ? 'Reproducir' : 'Pausar';
            this.button.textContent = label;
            this.button.setAttribute('aria-label', label + ' video de fondo');
          };
          listen(this.video, 'play', update); listen(this.video, 'pause', update);
          listen(this.video, 'loadeddata', () => this.syncVideo());
          listen(this.button, 'click', () => {
            if (this.video.paused) {
              this.userPaused = false; this.userStarted = true; this.blocked = false;
              this.startVideo();
            } else { this.userPaused = true; this.userStarted = false; this.video.pause(); }
          });
          update();
        }
        listen(this.motion, 'change', () => {
          if (this.motion.matches) { this.classList.remove('orb-ready'); reveal(); }
          this.userStarted = false; this.syncVideo();
        });
        listen(document, 'visibilitychange', () => this.syncVideo());
        listen(this, 'shopify:block:select', event => {
          reveal(); const item = event.target.closest('.orb-item');
          if (item) item.classList.add('orb-selected');
        });
        listen(this, 'shopify:block:deselect', event => {
          const item = event.target.closest('.orb-item');
          if (item) item.classList.remove('orb-selected');
        });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            const entry = entries[0]; this.visible = entry.isIntersecting;
            if (this.visible && entry.intersectionRatio >= .6) reveal();
            this.syncVideo();
          }, { threshold: [0, .6] });
          this.observer.observe(this);
        } else { this.visible = true; reveal(); }
        this.syncVideo();
      }
      startVideo() {
        if (this.pending || this.blocked || !this.video) return;
        this.pending = true;
        this.video.play().then(() => {
          if (!this.isConnected) this.video.pause(); else this.syncVideo();
        }).catch(error => {
          if (error.name !== 'AbortError') { this.blocked = true; this.video.dataset.playbackError = error.name; }
        }).finally(() => { this.pending = false; });
      }
      syncVideo() {
        if (!this.video) return;
        if (this.visible && !document.hidden && !this.userPaused && (!this.motion.matches || this.userStarted)) {
          if (this.video.paused) this.startVideo();
        } else this.video.pause();
      }
      disconnectedCallback() {
        if (this.onReady) document.removeEventListener('DOMContentLoaded', this.onReady);
        this.onReady = null; cancelAnimationFrame(this.startFrame); this.startFrame = null;
        cancelAnimationFrame(this.sizeFrame); this.observer?.disconnect(); this.resizeObserver?.disconnect();
        this.dispose?.forEach(fn => fn()); this.dispose = null; this.video?.pause();
        this.classList.remove('orb-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-mapa-origenes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cafe-origins-map')) {
    customElements.define(
      'cafe-origins-map',
      class extends HTMLElement {
        connectedCallback() {
          this.frame = requestAnimationFrame(() => this.init());
        }

        async init() {
          if (this.ready) return;
          this.ready = true;

          this.abort = new AbortController();
          const signal = this.abort.signal;

          this.desktop = matchMedia(
            '(min-width:1100px) and (hover:hover) and (pointer:fine)'
          );

          this.reduced = matchMedia(
            '(prefers-reduced-motion:reduce)'
          );

          this.cards = Array.from(
            this.querySelectorAll('[data-card]')
          );

          this.states = [];
          this.stage = this.querySelector('.mo-stage');
          this.mapContainer = this.querySelector('.mo-map');

          this.fit = () => {
            this.style.width = '';
            this.style.marginLeft = '';

            const left = this.getBoundingClientRect().left;

            this.style.width =
              document.documentElement.clientWidth + 'px';

            this.style.marginLeft = -left + 'px';
          };

          this.fit();

          window.addEventListener(
            'resize',
            this.fit,
            { signal }
          );

          this.setupVideo(signal);

          try {
            const response = await fetch(
              this.dataset.mapUrl,
              { signal }
            );

            if (!response.ok) {
              throw new Error('No se pudo cargar mapa.svg');
            }

            const source = await response.text();
            if (signal.aborted) return;

            const parsed = new DOMParser().parseFromString(
              source,
              'image/svg+xml'
            );

            if (parsed.querySelector('parsererror')) {
              throw new Error('SVG inválido');
            }

            const svg = parsed.documentElement;

            if (svg.localName !== 'svg') {
              throw new Error('El archivo no es un SVG');
            }

            const stateNames = {
              'Veracruz': 'veracruz',
              'Chiapas': 'chiapas',
              'Oaxaca': 'oaxaca',
              'Michoacán': 'michoacan',
              'Guerrero': 'guerrero'
            };

            svg.querySelectorAll(
              'script, foreignObject, style'
            ).forEach((element) => element.remove());

            svg.querySelectorAll('.st0').forEach((element) => {
              element.setAttribute('fill-rule', 'evenodd');
            });

            svg.querySelectorAll('[id]').forEach((element) => {
              const name = element.getAttribute('id');

              if (stateNames[name]) {
                element.setAttribute(
                  'data-state',
                  stateNames[name]
                );
                element.setAttribute('aria-label', name);
              }

              if (name === 'Contorno_México') {
                element.setAttribute('class', 'mo-outline');
              }

              element.removeAttribute('id');
            });

            [svg, ...svg.querySelectorAll('*')].forEach((element) => {
              Array.from(element.attributes).forEach((attribute) => {
                if (/^on/i.test(attribute.name)) {
                  element.removeAttribute(attribute.name);
                }
              });
            });

            svg.setAttribute('class', 'mo-svg');
            svg.setAttribute(
              'aria-label',
              'Mapa de los orígenes de nuestro café'
            );

            this.mapContainer.replaceChildren(
              document.importNode(svg, true)
            );

            const mountedSvg = this.mapContainer.querySelector('svg');
            const box = mountedSvg.getBBox();

            if (box.width > 0 && box.height > 0) {
              mountedSvg.setAttribute(
                'viewBox',
                [
                  box.x - 15,
                  box.y - 15,
                  box.width + 30,
                  box.height + 30
                ].join(' ')
              );
            }

            this.states = Array.from(
              this.querySelectorAll('[data-state]')
            );

            if (!this.states.length) {
              throw new Error('No se encontraron los estados');
            }

            this.bindMap(signal);
            this.classList.add('is-enhanced');
            this.clear();
            this.fit();
          } catch (error) {
            if (signal.aborted) return;

            this.classList.remove('is-enhanced');

            const message = document.createElement('p');
            message.className = 'mo-status';
            message.textContent =
              'No se pudo cargar el mapa. Verifica que mapa.svg esté en Assets y conserve los nombres de los estados.';

            this.mapContainer.replaceChildren(message);
          }
        }

        bindMap(signal) {
          this.states.forEach((state) => {
            const card = this.cards.find(
              (item) => item.dataset.card === state.dataset.state
            );

            if (!card) {
              state.setAttribute('aria-disabled', 'true');
              return;
            }

            state.setAttribute('role', 'button');
            state.setAttribute('tabindex', '0');
            state.setAttribute('aria-controls', card.id);
            state.setAttribute('aria-expanded', 'false');

            state.addEventListener(
              'pointerenter',
              () => {
                if (this.desktop.matches) {
                  this.select(state.dataset.state);
                }
              },
              { signal }
            );

            state.addEventListener(
              'focus',
              () => this.select(state.dataset.state),
              { signal }
            );

            const activate = () => {
              this.select(state.dataset.state);

              if (!this.desktop.matches) {
                card.scrollIntoView({
                  behavior: this.reduced.matches ? 'auto' : 'smooth',
                  block: 'nearest'
                });

                card.focus({ preventScroll: true });
              }
            };

            state.addEventListener(
              'click',
              activate,
              { signal }
            );

            state.addEventListener(
              'keydown',
              (event) => {
                if (
                  event.key === 'Enter' ||
                  event.key === ' '
                ) {
                  event.preventDefault();
                  activate();
                }
              },
              { signal }
            );
          });

          this.stage.addEventListener(
            'pointerleave',
            () => {
              if (
                this.desktop.matches &&
                !this.stage.contains(document.activeElement)
              ) {
                this.clear();
              }
            },
            { signal }
          );

          this.stage.addEventListener(
            'focusout',
            () => {
              queueMicrotask(() => {
                if (signal.aborted) return;

                if (
                  !this.stage.contains(document.activeElement) &&
                  !this.stage.matches(':hover')
                ) {
                  this.clear();
                }
              });
            },
            { signal }
          );

          this.addEventListener(
            'keydown',
            (event) => {
              if (event.key === 'Escape') {
                this.clear();
              }
            },
            { signal }
          );

          this.desktop.addEventListener(
            'change',
            () => {
              this.clear();
              this.fit();
            },
            { signal }
          );

          document.addEventListener(
            'shopify:block:select',
            (event) => {
              const card = this.cards.find(
                (item) => item.dataset.block === event.detail.blockId
              );

              if (card) {
                this.select(card.dataset.card);
              }
            },
            { signal }
          );

          document.addEventListener(
            'shopify:block:deselect',
            (event) => {
              const belongsHere = this.cards.some(
                (item) => item.dataset.block === event.detail.blockId
              );

              if (belongsHere) {
                this.clear();
              }
            },
            { signal }
          );
        }

        select(key) {
          this.classList.add('has-selection');

          this.states.forEach((state) => {
            const active = state.dataset.state === key;

            state.classList.toggle('is-selected', active);

            if (state.hasAttribute('role')) {
              state.setAttribute(
                'aria-expanded',
                String(active || !this.desktop.matches)
              );
            }
          });

          this.cards.forEach((card) => {
            const active = card.dataset.card === key;

            card.classList.toggle('is-selected', active);

            card.setAttribute(
              'aria-hidden',
              String(this.desktop.matches && !active)
            );
          });
        }

        clear() {
          this.classList.remove('has-selection');

          this.states.forEach((state) => {
            state.classList.remove('is-selected');

            if (state.hasAttribute('role')) {
              state.setAttribute(
                'aria-expanded',
                String(!this.desktop.matches)
              );
            }
          });

          this.cards.forEach((card) => {
            card.classList.remove('is-selected');

            card.setAttribute(
              'aria-hidden',
              String(this.desktop.matches)
            );
          });
        }

        setupVideo(signal) {
          this.video = this.querySelector('video');
          if (!this.video) return;

          const button = this.querySelector('.mo-video-button');

          this.video.muted = true;
          this.video.defaultMuted = true;
          this.video.playsInline = true;

          button.hidden = false;
          this.userPaused = false;

          this.play = () => {
            const promise = this.video.play();

            if (promise) {
              promise.catch(() => {
                button.textContent = 'Reproducir video';
              });
            }
          };

          button.addEventListener(
            'click',
            () => {
              if (this.video.paused) {
                this.userPaused = false;
                this.play();
              } else {
                this.userPaused = true;
                this.video.pause();
              }
            },
            { signal }
          );

          this.video.addEventListener(
            'play',
            () => {
              button.textContent = 'Pausar video';
            },
            { signal }
          );

          this.video.addEventListener(
            'pause',
            () => {
              button.textContent = 'Reproducir video';
            },
            { signal }
          );

          this.reduced.addEventListener(
            'change',
            () => {
              if (this.reduced.matches) {
                this.video.pause();
              }
            },
            { signal }
          );

          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver((entries) => {
              const visible =
                entries[entries.length - 1].isIntersecting;

              if (!visible) {
                this.video.pause();
              } else if (
                !this.userPaused &&
                !this.reduced.matches
              ) {
                this.play();
              }
            });

            this.observer.observe(this);
          } else if (!this.reduced.matches) {
            this.play();
          }
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);

          if (this.abort) {
            this.abort.abort();
          }

          if (this.observer) {
            this.observer.disconnect();
          }

          if (this.video) {
            this.video.pause();
          }

          this.classList.remove('is-enhanced', 'has-selection');

          if (this.cards) {
            this.cards.forEach((card) => {
              card.removeAttribute('aria-hidden');
              card.classList.remove('is-selected');
            });
          }

          this.ready = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-pantalla-completa"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cafe-fullscreen')) {
    customElements.define('cafe-fullscreen', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup || this.startFrame) return;
        this.startFrame = requestAnimationFrame(() => {
          this.startFrame = null;
          if (this.isConnected) this.initialize();
        });
      }
      initialize() {
        if (this.cleanup) return;
        this.cleanup = [];
        const listen = (target, type, handler) => {
          target.addEventListener(type, handler);
          this.cleanup.push(() => target.removeEventListener(type, handler));
        };
        const resize = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            // Measure the normal content origin before expanding to viewport width.
            this.style.setProperty('--cfs-left', '0px');
            this.style.setProperty('--cfs-width', '100%');
            const left = this.getBoundingClientRect().left;
            this.style.setProperty('--cfs-left', -left + 'px');
            this.style.setProperty('--cfs-width', document.documentElement.clientWidth + 'px');
            this.style.setProperty('--cfs-legacy-height', window.innerHeight + 'px');
          });
        };
        listen(window, 'resize', resize);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(resize);
          this.resizeObserver.observe(document.documentElement);
          if (this.parentElement) this.resizeObserver.observe(this.parentElement);
        }
        resize();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        if (this.dataset.ovals === 'true' && !this.motion.matches && 'IntersectionObserver' in window) {
          this.classList.add('cfs-oval-ready');
          this.ovalObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.6)) {
              this.classList.add('cfs-oval-visible');
              this.ovalObserver.disconnect();
            }
          }, { threshold: [0, 0.6] });
          this.ovalObserver.observe(this);
        }
        listen(this.motion, 'change', () => {
          if (this.motion.matches) {
            this.classList.remove('cfs-oval-ready');
            this.ovalObserver?.disconnect();
          }
        });
        this.video = this.querySelector('video');
        const button = this.querySelector('.cfs-video-toggle');
        if (!this.video || !button) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.userPaused = false;
        this.userStarted = false;
        button.hidden = false;
        this.video.muted = true;
        const update = () => {
          const label = this.video.paused ? 'Reproducir' : 'Pausar';
          button.textContent = label;
          button.setAttribute('aria-label', label + ' video de fondo');
        };
        const sync = () => {
          const play = this.visible && !document.hidden && !this.userPaused && (!this.motion.matches || this.userStarted);
          if (play) { if (this.video.paused) this.video.play().catch(() => {}); }
          else this.video.pause();
        };
        listen(this.video, 'play', update);
        listen(this.video, 'pause', update);
        listen(button, 'click', () => {
          if (this.video.paused) {
            this.userPaused = false; this.userStarted = true;
            this.video.play().catch(() => {});
          } else { this.userPaused = true; this.userStarted = false; this.video.pause(); }
        });
        listen(document, 'visibilitychange', sync);
        listen(this.motion, 'change', () => { this.userStarted = false; sync(); });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting; sync();
          }, { threshold: 0.05 });
          this.observer.observe(this);
        } else { this.visible = true; sync(); }
        update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame); this.startFrame = null;
        this.ovalObserver?.disconnect();
        this.classList.remove('cfs-oval-ready');
        cancelAnimationFrame(this.frame);
        this.resizeObserver?.disconnect();
        this.observer?.disconnect();
        this.cleanup?.forEach(fn => fn());
        this.cleanup = null;
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp_video_maquina_escribir"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cafe-typewriter-banner')) {
  customElements.define(
    'cafe-typewriter-banner',
    class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }

      init() {
        if (this.ready) return;
        this.ready = true;

        this.abort = new AbortController();
        const signal = this.abort.signal;

        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.video = this.querySelector('video');
        this.control = this.querySelector('.cw-video-control');

        this.originals = [];
        this.queue = [];
        this.active = false;
        this.userPaused = false;
        this.started = false;
        this.part = 0;
        this.timer = null;

        this.resize = () => {
          this.style.width = '';
          this.style.marginLeft = '';

          const rect = this.getBoundingClientRect();

          this.style.width =
            document.documentElement.clientWidth + 'px';

          this.style.marginLeft = -rect.left + 'px';
        };

        this.resize();
        window.addEventListener('resize', this.resize, { signal });

        if (this.video) {
          this.video.muted = true;
          this.video.defaultMuted = true;
          this.video.playsInline = true;
          this.control.hidden = false;

          this.control.addEventListener(
            'click',
            () => {
              if (this.video.paused) {
                this.userPaused = false;
                this.play();
              } else {
                this.userPaused = true;
                this.video.pause();
              }
            },
            { signal }
          );

          this.video.addEventListener(
            'play',
            () => {
              this.control.textContent = 'Pausar video';
            },
            { signal }
          );

          this.video.addEventListener(
            'pause',
            () => {
              this.control.textContent = 'Reproducir video';
            },
            { signal }
          );
        }

        if (!this.motion.matches) {
          this.querySelectorAll('[data-type]').forEach((el) => {
            const animateTitle =
              this.dataset.animateTitle === 'true';

            const animateBody =
              this.dataset.animateBody === 'true';

            if (
              (el.dataset.type === 'title' && !animateTitle) ||
              (el.dataset.type === 'body' && !animateBody)
            ) {
              return;
            }

            const text = el.textContent;
            this.originals.push([el, text]);

            const sr = document.createElement('span');
            sr.className = 'cw-sr';
            sr.textContent = text;

            const visual = document.createElement('span');
            visual.className = 'cw-visual';
            visual.setAttribute('aria-hidden', 'true');

            const ghost = document.createElement('span');
            ghost.className = 'cw-ghost';
            ghost.textContent = text;

            const typed = document.createElement('span');
            typed.className = 'cw-typed';

            const output = document.createTextNode('');

            const caret = document.createElement('span');
            caret.className = 'cw-caret';
            caret.hidden = true;

            typed.append(output, caret);
            visual.append(ghost, typed);
            el.replaceChildren(sr, visual);

            const chars =
              typeof Intl.Segmenter === 'function'
                ? Array.from(
                    new Intl.Segmenter(
                      document.documentElement.lang || 'es',
                      { granularity: 'grapheme' }
                    ).segment(text),
                    (x) => x.segment
                  )
                : Array.from(text);

            this.queue.push({
              output,
              caret,
              chars,
              index: 0
            });
          });
        }

        this.motion.addEventListener(
          'change',
          () => {
            if (this.motion.matches) {
              clearTimeout(this.timer);
              this.timer = null;

              this.originals.forEach(([el, text]) => {
                el.textContent = text;
              });

              this.queue = [];

              if (this.video) {
                this.video.pause();
              }
            }
          },
          { signal }
        );

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              const entry = entries[entries.length - 1];
              this.active = entry.isIntersecting;

              if (!this.active) {
                clearTimeout(this.timer);
                this.timer = null;

                if (this.video) {
                  this.video.pause();
                }

                return;
              }

              if (
                this.video &&
                !this.motion.matches &&
                !this.userPaused &&
                this.video.paused
              ) {
                this.play();
              }

              const target =
                Math.min(
                  entry.boundingClientRect.height,
                  entry.rootBounds
                    ? entry.rootBounds.height
                    : innerHeight
                ) * 0.6;

              if (
                !this.started &&
                entry.intersectionRect.height >= target
              ) {
                this.started = true;
                this.schedule(Number(this.dataset.delay));
              } else if (this.started) {
                this.schedule(Number(this.dataset.speed));
              }
            },
            {
              threshold: Array.from(
                { length: 101 },
                (_, i) => i / 100
              )
            }
          );

          this.observer.observe(this);
        } else {
          this.active = true;
          this.started = true;
          this.schedule(Number(this.dataset.delay));

          if (this.video && !this.motion.matches) {
            this.play();
          }
        }
      }

      play() {
        const pending = this.video.play();

        if (pending) {
          pending.catch(() => {
            if (this.control) {
              this.control.textContent = 'Reproducir video';
            }
          });
        }
      }

      schedule(delay) {
        if (this.timer || !this.queue[this.part]) return;

        this.timer = setTimeout(() => {
          this.timer = null;
          this.tick();
        }, delay);
      }

      tick() {
        if (!this.active || !this.isConnected) return;

        const item = this.queue[this.part];
        if (!item) return;

        item.caret.hidden = false;

        if (item.index < item.chars.length) {
          item.output.appendData(item.chars[item.index++]);
          this.schedule(Number(this.dataset.speed));
        } else if (this.part < this.queue.length - 1) {
          item.caret.hidden = true;
          this.part++;
          this.schedule(300);
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);
        this.timer = null;

        if (this.observer) {
          this.observer.disconnect();
        }

        if (this.abort) {
          this.abort.abort();
        }

        if (this.video) {
          this.video.pause();
        }

        if (this.originals) {
          this.originals.forEach(([el, text]) => {
            el.textContent = text;
          });
        }

        this.ready = false;
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();
})();
